<div class="detail-header flex flex-col gap-5 w-full">
  @if (config.breadcrumbs?.length) {
    <nav class="detail-header__breadcrumbs flex flex-wrap items-center gap-2 text-sm" aria-label="Breadcrumb">
      @for (crumb of config.breadcrumbs; track $index; let last = $last) {
        @if (!last) {
          @if (crumb.route) {
            <a [routerLink]="crumb.route" class="detail-header__crumb-link shrink-0">{{ crumb.label }}</a>
          } @else {
            <span class="detail-header__crumb-link shrink-0">{{ crumb.label }}</span>
          }
          <span class="detail-header__crumb-sep shrink-0" aria-hidden="true">&gt;</span>
        } @else {
          <span class="detail-header__crumb-current font-semibold min-w-0 break-words">{{ crumb.label }}</span>
        }
      }
    </nav>
  }

  <div class="detail-header__card rounded-lg w-full flex flex-col gap-4">
    <div class="detail-header__title-row flex flex-wrap items-start justify-between gap-3">
      <h1 class="detail-header__title m-0 break-words min-w-0 flex-1">{{ config.title }}</h1>
      @if (config.assetId || showAssetActions) {
        <div class="detail-header__actions detail-header__actions--toolbar flex flex-wrap items-center shrink-0">
          @if (config.assetId) {
            <button
              type="button"
              class="detail-header__action-btn"
              (click)="copyAssetId()"
              [attr.aria-label]="'Copy asset ID'"
              [title]="copySuccess ? 'Copied!' : 'Copy asset ID'"
            >
              <svg
                class="detail-header__action-icon"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <rect
                  x="9"
                  y="9"
                  width="13"
                  height="13"
                  rx="2"
                  ry="2"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              @if (copySuccess) {
                <span class="detail-header__copy-success">Copied!</span>
              }
            </button>
          }
          @if (showAssetActions) {
            <button
              type="button"
              class="detail-header__action-btn"
              [class.detail-header__action-btn--active]="isLiked"
              (click)="onLikeClick()"
              [attr.aria-label]="isLiked ? 'Unlike this asset' : 'Like this asset'"
              [title]="isLiked ? 'Unlike' : 'Like'"
            >
              @if (!isLoggedIn) {
                <svg
                  class="detail-header__lock-icon"
                  width="11"
                  height="11"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
              <svg
                class="detail-header__action-icon"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                  [attr.fill]="isLiked ? 'currentColor' : 'none'"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button
              type="button"
              class="detail-header__action-btn"
              [class.detail-header__action-btn--active]="isBookmarked"
              (click)="onBookmarkClick()"
              [attr.aria-label]="isBookmarked ? 'Remove bookmark' : 'Bookmark this asset'"
              [title]="isBookmarked ? 'Remove bookmark' : 'Bookmark this asset'"
            >
              @if (!isLoggedIn) {
                <svg
                  class="detail-header__lock-icon"
                  width="11"
                  height="11"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
              <svg
                class="detail-header__action-icon"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M19 21L12 16L5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21Z"
                  [attr.fill]="isBookmarked ? 'currentColor' : 'none'"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          }
        </div>
      }
    </div>

    <div class="detail-header__meta flex flex-col gap-3">
      @if (config.shortDescription !== undefined) {
        @if (config.shortDescription) {
          <div class="detail-header__row inline-flex items-start">
            <p class="detail-header__meta-text detail-header__description m-0 line-clamp-4">{{ config.shortDescription }}</p>
          </div>
        }
      } @else {
        <div class="detail-header__row inline-flex items-start gap-2">
          <img src="/icons/building-3.svg" alt="" width="20" height="20" class="detail-header__icon shrink-0 mt-0.5" />
          <p class="detail-header__meta-text m-0">
            Published by <strong class="detail-header__strong">{{ config.publishedBy || '—' }}</strong>
          </p>
        </div>
      }
      <div class="detail-header__row inline-flex items-start gap-2">
        <svg
          class="detail-header__icon detail-header__icon--clock shrink-0 mt-0.5"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
          <path d="M12 7v5l3 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        <p class="detail-header__meta-text m-0">{{ config.updatedAt || '—' }}</p>
      </div>
    </div>
  </div>
</div>
